import React from 'react';
import {
  makeStyles,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Container
} from '@material-ui/core';
import { Menu } from '@material-ui/icons';

import LinkedLogo from './Shared/LinkedLogo';
import NavItems from './Shared/NavItems';
import AnnouncementBar from './AnnouncementBar';
import CartHeaderIcon from 'components/cart/CartHeaderIcon';
import { useWidth } from 'utils/hooks/useWidth';

interface HeaderProps {
  pageTitle?: string;
  onOpenDrawer: () => void;
  onOpenCart: () => void;
  hideNavigation?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  pageTitle,
  onOpenDrawer,
  onOpenCart,
  hideNavigation = false
}): JSX.Element => {
  const classes = useStyles();
  const width = useWidth();
  const isDesktop = width === 'md' || width === 'lg' || width === 'xl';

  return (
    <AppBar position="static" color="transparent" className={classes.appBar} elevation={0}>
      <AnnouncementBar />

      <Toolbar className={classes.toolbar} disableGutters>
        <Container className={classes.toolbarContent}>
          <Box className={classes.logoContainer}>
            <LinkedLogo heigth={isDesktop ? 72 : 64} width={isDesktop ? 57 : 51} />
          </Box>

          {pageTitle && (
            <Typography variant="h6" component="h1" className={classes.title}>
              {pageTitle}
            </Typography>
          )}

          {!hideNavigation && (
            <>
              <NavItems onOpenCart={onOpenCart} />

              <IconButton
                className={classes.menuButton}
                color="inherit"
                aria-label="open drawer"
                onClick={onOpenDrawer}
              >
                <Menu />
              </IconButton>
            </>
          )}

          <CartHeaderIcon onClick={onOpenCart} className={classes.cartButton} />
        </Container>
      </Toolbar>
    </AppBar>
  );
};

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1
  },
  appBar: {
    position: 'relative',
    marginBottom: theme.spacing(4)
  },
  toolbar: {
    paddingTop: 60,
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    }
  },
  toolbarContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row'
    }
  },
  logoContainer: {
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
      marginRight: theme.spacing(4),
      flexShrink: 0
    }
  },
  menuButton: {
    position: 'absolute',
    top: theme.spacing(6),
    left: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  cartButton: {
    position: 'absolute',
    top: theme.spacing(6),
    right: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }
}));

export default Header;
